{
    "CodeList_Column_Description": "Description",
    "CodeList_Column_Code": "Code",
    "CodeList_Column_Type": "Taper",
    "CodeList_Column_TelSys": "Serveur de téléphonie",
    "CodeList_Column_Partition": "Partition",
    "CodeList_Partition_Any": "N'importe lequel",
    "CodeList_Scope_All": "Tous",
    "CodeList_Scope_ServiceWide": "Service à l'échelle de l'ensemble du service",
    "CodeList_Scope_SystemWide": "Système global",
    "CodeList_Scope_Detached": "Détaché",
    "CodeList_Type_All": "Tous",
    "CodeList_Type_Account": "Compte",
    "CodeList_Type_ACD_NotAvailable": "ACD non disponible",
    "CodeList_Scope_Label": "Portée",
    "CodeList_Type_Label": "Taper",
    "CodeList_Change_AnyPartitionNotSupported": "Les codes de la partition « Toutes » ne peuvent être ni modifiés ni consultés ici. Filtrez la liste par partition spécifique pour modifier ou consulter un code.",
    "NAME": "CodeListLanguage"
}